import CONFIG from '../../CONFIG.js';

class Analytics {
	#inited = false;
	constructor() {
		this.gtm_id = CONFIG.gtm_id || null;

		if (this.gtm_id) {
			this.init();
		}
	}

	init() {
		if (!this.gtm_id) return;
		if (this.#inited) return;

		this.#inited = true;
		this.init_gtm();
	}

	init_gtm() {
		(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
		new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
		j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
		'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
		})(window,document,'script','dataLayer',this.gtm_id);

		const noscript = document.createElement('noscript');
		const iframe = document.createElement('iframe');
		iframe.src = `https://www.googletagmanager.com/ns.html?id=${this.gtm_id}`;
		iframe.height = '0';
		iframe.width = '0';
		iframe.style.display = 'none';
		iframe.style.visibility = 'hidden';
		noscript.appendChild(iframe);
		if(document.body.firstChild){
			document.body.insertBefore(noscript, document.body.firstChild);
		} else {
			document.body.appendChild(noscript);
		}
	}

	track_popup_open(uid) {
		if (!this.#inited || !window.dataLayer) return;

		const event_data = {
			event: 'custom_event',
			analytics_id: 'link',
			analytics_action: 'open card',
			analytics_detail: uid || ''
		};

		window.dataLayer.push(event_data);
	}

	track_menu_click(name) {
		if (!this.#inited || !window.dataLayer) return;

		const event_data = {
			event: 'custom_event',
			analytics_id: 'carousel',
			analytics_action: 'menu click',
			analytics_detail: name || ''
		};

		window.dataLayer.push(event_data);
	}

	track_menu_click_external(name) {
		if (!this.#inited || !window.dataLayer) return;

		const event_data = {
			event: 'custom_event',
			analytics_id: 'carousel',
			analytics_action: 'menu click',
			analytics_detail: name || ''
		};

		window.dataLayer.push(event_data);
	}

	track_submenu_click(name) {
		if (!this.#inited || !window.dataLayer) return;

		const event_data = {
			event: 'custom_event',
			analytics_id: 'carousel',
			analytics_action: 'submenu click',
			analytics_detail: name || ''
		};

		window.dataLayer.push(event_data);
	}
}

const analytics = new Analytics();

export default analytics;
